/**
 * Summer / winter toggle, ported from portal-ui-lib's `tyre-type-toggle` and drawn as the legacy
 * portal's `btn-group btn-sm`: the chosen season filled, the other outlined.
 *
 * `ALL_SEASON` is unreachable in frontend tyre-spec contexts (CLAUDE.md "Tyre Specs Frontend
 * Invariant"). Angular's toggle offered it to any caller that passed it; here the type does not
 * admit it, and options are filtered at runtime too, in case one arrives from untyped data.
 */
export type ToggleTyreType = 'SUMMER' | 'WINTER';

const ALLOWED: readonly ToggleTyreType[] = ['SUMMER', 'WINTER'];

export function TyreTypeToggle({
  value,
  onChange,
  labels,
  options = ALLOWED,
  label,
  className = '',
}: {
  value: ToggleTyreType;
  onChange: (value: ToggleTyreType) => void;
  /** From the feature's configuration texts. */
  labels: Record<ToggleTyreType, string>;
  options?: readonly ToggleTyreType[];
  /** Accessible name of the group. */
  label?: string;
  className?: string;
}) {
  const shown = options.filter((option): option is ToggleTyreType => ALLOWED.includes(option));
  return (
    <div role="group" aria-label={label} className={`inline-flex ${className}`}>
      {shown.map(option => {
        const active = option === value;
        return (
          <button
            key={option}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(option)}
            className={`-ml-px border border-brand px-2 py-1 text-xs leading-[1.5] transition-colors first:ml-0 first:rounded-l-bs-sm last:rounded-r-bs-sm ${active ? 'z-10 bg-brand text-white' : 'bg-transparent text-brand hover:bg-brand hover:text-white'}`}
          >
            {labels[option]}
          </button>
        );
      })}
    </div>
  );
}
